<script setup lang="ts">
    import { InputRow, Select } from '@/components/ui/form';
    import { Input } from '@/components/ui/input';
    import { optionsYesNo } from '@/utils/form';

    defineProps<{
        form: any;
    }>();
</script>

<template>
    <div class="grid gap-3 sm:grid-cols-1">
        <InputRow
            :form="form"
            name="data_field_name"
            label="system.data_field_name"
        >
            <Input
                id="data_field_name"
                v-model="form.data_field_name"
                :placeholder="$t('system.data_field_name')"
            />
        </InputRow>
        <InputRow
            :form="form"
            name="data_field_status"
            label="system.data_field_approve"
        >
            <Select
                v-model="form.data_field_status"
                :options="optionsYesNo"
                :translate="true"
            />
        </InputRow>
        <InputRow
            :form="form"
            name="data_field_group"
            label="system.data_fields.group"
        >
            <Select
                v-model="form.data_field_group"
                :options="[
                    { value: 'bookkeeping_status', label: 'system.bookkeeping_status' },
                    { value: 'report_status', label: 'system.report_status' },
                    { value: 'vat_status', label: 'system.vat_status' },
                    { value: 'pbc_status', label: 'system.pbc_status' },
                    { value: 'annual_report', label: 'system.annual_report' },
                ]"
                :translate="true"
            />
        </InputRow>
        <InputRow
            :form="form"
            name="data_field_color"
            label="system.data_fields.color"
        >
            <Select
                v-model="form.data_field_color"
                :options="[
                    { value: 'yellow', label: 'system.data_field_colors.yellow' },
                    { value: 'red', label: 'system.data_field_colors.red' },
                    { value: 'green', label: 'system.data_field_colors.green' },
                    { value: 'blue', label: 'system.data_field_colors.blue' },
                    { value: 'baby_blue', label: 'system.data_field_colors.baby_blue' },
                    { value: 'bright_yellow', label: 'system.data_field_colors.bright_yellow' },
                ]"
                :translate="true"
            />
        </InputRow>
    </div>
</template>
